/**
 * Full-screen lazy-chunk loading overlay (formerly exported as
 * `LoadingSpinner`, renamed to stop colliding with the inline
 * `LoadingSpinner` in ui/LoadingStates.tsx — two same-named exports
 * with totally different designs).
 */
import { useTranslation } from '@/lib/i18n/useTranslation';

export function FullScreenLoader() {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/20 backdrop-blur-sm z-50">
      <div className="glass-card-dark p-6 rounded-2xl">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 border-4 border-blue-400 border-t-transparent rounded-full animate-spin" />
          <span className="text-white font-medium">{t('common.loading')}</span>
        </div>
      </div>
    </div>
  );
}
